// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function scrollAncestorsToTop(domElement) {
  if (domElement.scrollTop > 0) {
    domElement.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  Stdlib_Option.forEach(Primitive_option.fromNullable(domElement.parentElement), scrollAncestorsToTop);
}

export {
  scrollAncestorsToTop,
}
/* No side effect */
